import React from "react";
import Tooltip from "../ui/Tooltip";
import Icon from "../icons/Icons";

type StatItem = {
  label: string;
  value: string | number;
  highlightVal?: number;
};

type InvestmentStrategy = {
  stats: StatItem[];
  description: string;
  objective: string;
};

export default function SIFInvestmentOverviewStep({ data }: { data: InvestmentStrategy }) {
  return (
    <>
      {/* Stats */}
      <div className="grid grid-cols-2 xs:grid-cols-4 gap-4 sm:gap-6 mb-4 sm:mb-6">
        {data.stats.map((item) => (
          <div
            key={item.label}
            className="w-full rounded-2xl border border-white/15 bg-white/5 p-3 text-center space-y-1.5"
          >
            <p className="text-sm text-white/60">{item.label}</p>

            {item.label === "Lock-in" ? (
              <div className="flex items-center justify-center gap-2">
                <span
                  className={`leading-1.2 font-medium truncate ${item.highlightVal ? (item.highlightVal > 0 ? "text-green-500" : "text-red-500") : "text-white"}`}
                >
                  {item.value || "N/A"}
                </span>

                {item.value !== "None" && item.value !== "NIL" && item.value !== "" && (
                  <Tooltip content={item.value} trigger="click" position="bottom-right" className="w-4 h-4 shrink-0">
                    <button className="w-4 h-4">
                      <Icon.infoIcon className="w-4 h-4 rotate-180 transition text-white/70 hover:text-white" />
                    </button>
                  </Tooltip>
                )}
              </div>
            ) : (
              <p
                className={`leading-1.2 font-medium ${item.highlightVal ? (item.highlightVal > 0 ? "text-green-500" : "text-red-500") : "text-white"}`}
              >
                {item.value}
              </p>
            )}
          </div>
        ))}
      </div>

      {/* Description */}
      {data.description && (
        <div className="rounded-2xl border border-white/15 bg-white/5 p-4 mb-5">
          <div className="font-semibold leading-1.2 mb-4">Investment Strategy</div>
          <p className="text-sm text-white/70 leading-1.5 max-h-24 overflow-y-auto scrollbar-xs pr-1.5">
            {data.description}
          </p>
        </div>
      )}

      {/* Objective */}
      {data.objective && (
        <div className="rounded-2xl border border-white/15 bg-white/5 p-4">
          <div className="font-semibold leading-1.2 mb-4">Investment Objective</div>
          <p className="text-sm text-white/70 leading-1.5 max-h-24 overflow-y-auto scrollbar-xs pr-1.5">
            {data.objective}
          </p>
        </div>
      )}
    </>
  );
}
